import {
    SET_SOFT_CHECK_ACCEPTED_INCOME_CHECK,
    SET_SOFT_CHECK_ACCEPTED_SOFT_CHECK,
    SET_DIP,
    GET_DIP_ERROR,
    GET_DIP_FULFILLED,
    GET_DIP_PENDING,
} from '../../../constants/ActionTypes';
import softCheckInitialState from './softCheckInitialState';

function softCheckReducer(state = softCheckInitialState, action) {
    switch (action.type) {
    case SET_SOFT_CHECK_ACCEPTED_INCOME_CHECK:
        return {
            ...state,
            consents: {
                ...state.consents,
                acceptedIncomeCheck: action.acceptedIncomeCheck,
            },
        };
    case SET_SOFT_CHECK_ACCEPTED_SOFT_CHECK:
        return {
            ...state,
            consents: {
                ...state.consents,
                acceptedSoftCheck: action.acceptedSoftCheck,
            },
        };
    case SET_DIP:
        return {
            ...state,
            isPending: false,
            decision: action.data.decision,
            maxLendAmount: action.data.maxLendAmount,
        };
    case GET_DIP_PENDING:
        return {
            ...state,
            isPending: true,
            decision: '',
            maxLendAmount: {
                amount: 0,
                currency: 'gbp',
            },
        };
    case GET_DIP_FULFILLED:
        return {
            ...state,
            decision: action.payload.decision,
            maxLendAmount: action.payload.maxLendAmount,
            data: action.payload.data,
            isPending: false,
            isError: false,
        };
    case GET_DIP_ERROR:
        return {
            ...state,
            isError: true,
            errorMessage: action.error,
            isPending: false,
        };
    default:
        return state;
    }
}

export default softCheckReducer;



// WEBPACK FOOTER //
// ./src/app/FormStepper/SoftCheck/softCheckReducer.js